import { Rating } from "react-simple-star-rating";
import { RxStar, RxStarFilled } from "react-icons/rx";

import { customerSurveyConstants } from "../../constants";

const { DEFAULT_STAR_COLOR, STAR_ICON_SIZE } = customerSurveyConstants;

const ReadonlyStarRating = ({ initialValue }) => {
  return (
    <Rating
      readonly
      allowHover={false}
      fillColor={DEFAULT_STAR_COLOR}
      initialValue={initialValue}
      fillIcon={<RxStarFilled size={STAR_ICON_SIZE} />}
      emptyIcon={
        <RxStar size={STAR_ICON_SIZE} color={DEFAULT_STAR_COLOR} />
      }
    />
  );
};

export default ReadonlyStarRating;
